<div class="footer-expand">
  <a
    tabIndex="0"
    aria-controls="linkBag"
    (keydown.code.Enter)="toggleFooter()"
    (click)="toggleFooter()">
    © Siemens Energy
    <span
      class="material-icons"
      [ariaLabel]="(showFooter() ? 'close' : 'open') + ' footer'">
      {{ showFooter() ? 'expand_more' : 'expand_less' }}
    </span>
  </a>
</div>
<div
  role="menubar"
  id="linkBag"
  class="footer"
  aria-orientation="horizontal"
  coinKeyboardMenuNavigation="[role='menuitem']"
  [ngClass]="{ 'footer--show': showFooter() }"
  [ariaExpanded]="showFooter()"
  [ariaHidden]="!showFooter()">
  @if (showFooter()) {
    <a
      role="menuitem"
      class="footer-item"
      href="https://www.siemens-energy.com/global/en.html">
      © Siemens Energy, {{ currentYear }}
    </a>
    <a
      role="menuitem"
      class="footer-item"
      href="https://www.siemens-energy.com/global/en/general/terms-of-use.html">
      Terms of Use
    </a>
    <a
      role="menuitem"
      class="footer-item"
      href="https://www.siemens-energy.com/global/en/general/digital-id.html">
      Digital ID
    </a>
    <a
      role="menuitem"
      class="footer-item"
      href="https://www.siemens-energy.com/global/en/general/corporate-information.html">
      Corporate Information
    </a>
    <a
      role="menuitem"
      class="footer-item"
      href="https://www.siemens-energy.com/global/en/general/cookie-notice.html">
      Cookie Notice
    </a>
    <a
      role="menuitem"
      class="footer-item"
      href="https://www.siemens-energy.com/global/en/general/privacy-notice.html">
      Privacy Notice
    </a>
    <ng-container *coinFeatureFlag="'customerGbrFooter'">
      <a
        role="menuitem"
        class="footer-item"
        routerLink="/gbr">
        GBR
      </a>
    </ng-container>
    <a
      role="menuitem"
      class="footer-item"
      routerLink="/service-provider">
      Service Provider
    </a>
  }
</div>
